"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadUrlResponse = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class DownloadUrlResponse extends base_models_1.Serializable {
}
exports.DownloadUrlResponse = DownloadUrlResponse;
tslib_1.__decorate([
    (0, class_validator_1.IsUrl)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, base_models_1.Docs)({
        description: 'direct download link for the requested document, just GET it',
        example: 'https://essent-integration-emobility-compressed-image-dev.s3.eu-central-1.amazonaws.com/emobility%2A012345%24random0123%24essent.jpg',
    }),
    tslib_1.__metadata("design:type", String)
], DownloadUrlResponse.prototype, "url", void 0);
